"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRendererType = void 0;
const ServerSideRendererType_1 = __importDefault(require("../../pluggableElementTypes/renderers/ServerSideRendererType"));
function validateRendererType(rendererType, RendererType) {
    if (!RendererType) {
        throw new Error(`renderer "${rendererType}" not found`);
    }
    // @ts-expect-error
    if (!RendererType.ReactComponent) {
        throw new Error(`renderer ${rendererType} has no ReactComponent, it may not be completely implemented yet`);
    }
    if (!(RendererType instanceof ServerSideRendererType_1.default)) {
        throw new TypeError('CoreRender requires a renderer that is a subclass of ServerSideRendererType');
    }
    return RendererType;
}
exports.validateRendererType = validateRendererType;
